module.exports = __webpack_public_path__ + "media/images/game/task/answered-2a2777801743f9411ae91e1f4a56b28d.png";